import { IconButton, InputBase, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useState } from "react";
import {
  Check as CheckIcon,
  GridView as GridViewIcon,
  ViewList as ViewListIcon,
  Sort as SortIcon,
  MoreHoriz as MoreHorizIcon,
  DarkMode as DarkModeIcon,
  LightMode as LightModeIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { ViewMode, SortBy } from "./App";

function Header({
  search,
  onSearchChange,
  setShowProgressDialog,
  viewMode,
  setViewMode,
  sortBy,
  setSortBy,
  colorMode,
  onColorModeToggle,
  onLogout,
}: {
  search: string;
  onSearchChange: (newSearch: string) => void;
  setShowProgressDialog: (show: boolean) => void;
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  sortBy: SortBy;
  setSortBy: (sort: SortBy) => void;
  colorMode: "light" | "dark";
  onColorModeToggle: () => void;
  onLogout: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [sortMenuAnchor, setSortMenuAnchor] = useState<null | HTMLElement>(null);

  return (
    <Toolbar disableGutters sx={{ padding: 1 }}>
      <InputBase
        size="small"
        fullWidth
        placeholder="Search…"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={(theme) => ({
          backgroundColor: colorMode === "dark" ? "#333" : "whitesmoke",
          borderRadius: "999px",
          padding: "8px 16px",
          color: theme.palette.text.primary,
        })}
      />
      <ToggleButtonGroup
        value={viewMode}
        exclusive
        onChange={(_, value) => value && setViewMode(value)}
        size="small"
        sx={{ marginLeft: 1 }}
      >
        <ToggleButton value="grid" aria-label="Grid view">
          <GridViewIcon />
        </ToggleButton>
        <ToggleButton value="list" aria-label="List view">
          <ViewListIcon />
        </ToggleButton>
      </ToggleButtonGroup>

      <IconButton
        aria-label="Toggle dark mode"
        color="inherit"
        sx={{ marginLeft: 0.5 }}
        onClick={onColorModeToggle}
      >
        {colorMode === "light" ? <DarkModeIcon /> : <LightModeIcon />}
      </IconButton>

      <IconButton
        aria-label="Sort"
        color="inherit"
        sx={{ marginLeft: 0.5 }}
        onClick={(e) => setSortMenuAnchor(e.currentTarget)}
      >
        <SortIcon />
      </IconButton>

      <IconButton
        aria-label="More"
        color="inherit"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreHorizIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setShowProgressDialog(true);
          }}
        >
          Progress
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            onLogout();
          }}
        >
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>

      <Menu
        anchorEl={sortMenuAnchor}
        open={Boolean(sortMenuAnchor)}
        onClose={() => setSortMenuAnchor(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => {
            setSortBy("name");
            setSortMenuAnchor(null);
          }}
        >
          <ListItemIcon>{sortBy === "name" && <CheckIcon fontSize="small" />}</ListItemIcon>
          <ListItemText>Name</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSortBy("date");
            setSortMenuAnchor(null);
          }}
        >
          <ListItemIcon>{sortBy === "date" && <CheckIcon fontSize="small" />}</ListItemIcon>
          <ListItemText>Date</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSortBy("size");
            setSortMenuAnchor(null);
          }}
        >
          <ListItemIcon>{sortBy === "size" && <CheckIcon fontSize="small" />}</ListItemIcon>
          <ListItemText>Size</ListItemText>
        </MenuItem>
      </Menu>
    </Toolbar>
  );
}

export default Header;
